/** Default Segco WhatsApp sales line. */
const DEFAULT_WHATSAPP_E164 = '27837841422';
const DEFAULT_WHATSAPP_DISPLAY = '+27 83 784 1422';

/** Normalize `REACT_APP_WHATSAPP_NUMBER` to E.164 digits for wa.me (no +). */
function parseWhatsAppE164(raw: string | undefined): string {
  if (!raw?.trim()) return DEFAULT_WHATSAPP_E164;
  let digits = raw.replace(/\D/g, '');
  if (digits.startsWith('0') && digits.length >= 10) {
    digits = `27${digits.slice(1)}`;
  }
  if (digits.length >= 10) return digits;
  return DEFAULT_WHATSAPP_E164;
}

function formatDisplay(e164: string): string {
  if (e164 === DEFAULT_WHATSAPP_E164) return DEFAULT_WHATSAPP_DISPLAY;
  if (e164.startsWith('27') && e164.length >= 11) {
    const local = e164.slice(2);
    return `+27 ${local.slice(0, 2)} ${local.slice(2, 5)} ${local.slice(5)}`.trim();
  }
  return `+${e164}`;
}

export const WHATSAPP_E164 = parseWhatsAppE164(process.env.REACT_APP_WHATSAPP_NUMBER);

export const WHATSAPP_DISPLAY = formatDisplay(WHATSAPP_E164);

export function buildWhatsAppUrl(text: string): string {
  return `https://wa.me/${WHATSAPP_E164}?text=${encodeURIComponent(text)}`;
}
